// extracted by mini-css-extract-plugin
export default {"coinContainer":"Landing_coinContainer__R1NMr","input":"Landing_input__23k0M"};